import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";

import Header from "../containers/Header";
import MainLayout from "../layouts/MainLayout";
import Footer from "../containers/Footer";
import InsurranceListShowCase from "../components/InsurranceListShowcase";

// For animations
import { Zoom } from "react-awesome-reveal";
import { motion } from "framer-motion";

import { fetchInsurrances } from "../apis";
import { Container } from "react-bootstrap";

function Insurrances() {
  const [insurrances, setInsurrances] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const { t } = useTranslation();

  const onFetchInsurrances = async () => {
    const langCode = cookies.get("i18next");
    try {
      const json = await fetchInsurrances(false, langCode);
      if (json) {
        setInsurrances(json);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Failed to fetch insurrances:", error?.response?.data ?? error.message);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    onFetchInsurrances();
  }, [t]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Header
        caption={t("insurance_page_header_title")}
        bgImg={
          "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1655461136/insurrances-img-header_mc60pr.svg"
        }
      />
      <MainLayout pageCSS="insurrance-page">
        <Zoom>
          <h2 className="">{t("inssurance_page_caption_text")}</h2>
        </Zoom>

        <Container>
          <InsurranceListShowCase
            items={insurrances}
            isLoading={isLoading}
            lg={4}
          />
        </Container>
      </MainLayout>
      <Footer />
    </motion.div>
  );
}

export default Insurrances;
